<h2 *ngIf="tenantForm.get('name')?.value" mat-dialog-title class="modal-header">
  {{ "master-tenant.edit" | translate }}: {{ tenantForm.get("name")?.value }}
  <button mat-icon-button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<h2
  *ngIf="!tenantForm.get('name')?.value"
  mat-dialog-title
  class="modal-header"
>
  {{ "master-tenant.new" | translate }}
  <button mat-icon-button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="modal-content">
  <form [formGroup]="tenantForm" class="tenant-form">
    <table class="tenant-table">
      <thead>
        <tr>
          <th>{{ "master-tenant.tenantName" | translate }}</th>
          <th>
            {{ "master-tenant.tenantAka" | translate }}
          </th>
          <th>
            {{ "master-tenant.parentCompany" | translate }}
          </th>
          <th *ngIf="platformId == 'br'">
            {{ "master-tenant.subIndustry" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input
              matInput
              formControlName="name"
              class="table-input form-control"
              (input)="removeDots($event)"
            />
          </td>
          <td>
            <input
              matInput
              formControlName="aka"
              class="table-input form-control"
            />
          </td>
          <td>
            <div
              style="text-align: start; width: 100%;"
              (click)="dropdownClicked = true"
            >
              <input
                type="text"
                [value]="parentCorporationNameValue"
                (input)="onInputChange($event)"
                (focus)="isDropdownOpen = true"
                placeholder="Type to search..."
                [ngClass]="{ loading: isLoading }"
                style="width: 100%; text-align: left;"
                class="form-control tenant-input"
              />
              <span *ngIf="isLoading" class="loading-icon">🔄</span>
              <ul
                *ngIf="tenantsList.length && isDropdownOpen && !isLoading"
                class="autocomplete-dropdown"
                [ngValue]="parentCorporation"
              >
                <li
                  *ngFor="let option of tenantsList"
                  (click)="onSelectOption(option)"
                  style="text-align: left; padding: 8px; cursor: pointer;"
                >
                  {{ option.name }}
                </li>
              </ul>
            </div>
          </td>
          <td *ngIf="platformId == 'br'">
            <select
              formControlName="industry"
              [compareWith]="compareIndustries"
              class="form-select"
            >
              <option *ngFor="let industry of industries" [ngValue]="industry"
                >{{ industry.name | langSelector }}
              </option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="tenant-table" *ngIf="corporation">
      <thead>
        <tr>
          <th>{{ "master-tenant.corporationId" | translate }}</th>
          <th>
            {{ "master-tenant.corporationStatus" | translate }}
          </th>
          <th>
            {{ "master-tenant.idsStatsBookingActions" | translate }}
          </th>
          <th>
            {{ "master-tenant.relatedPropertyIds" | translate }}
          </th>
          <th>
            {{ "master-tenant.relatedPropertyCount" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input matInput [value]="corporation?.id" disabled />
          </td>
          <td>
            <input matInput [value]="corporation?.status" disabled />
          </td>
          <td>
            <input
              [matTooltip]="corporation?.relatedPropertyIdsInStats"
              matTooltipPosition="after"
              matTooltipClass="large-tooltip"
              matInput
              [value]="corporation?.relatedPropertyIdsInStats"
              disabled
            />
          </td>
          <td>
            <input
              [matTooltip]="corporation?.relatedPropertyIds"
              matTooltipPosition="after"
              matTooltipClass="large-tooltip"
              matInput
              [value]="corporation?.relatedPropertyIds"
              disabled
            />
          </td>

          <td>
            <input matInput [value]="corporation?.propertyCount" disabled />
          </td>
        </tr>
      </tbody>
    </table>

    <table class="tenant-table">
      <thead>
        <tr>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.tag" | translate }}
          </th>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.subIndustry" | translate }}
          </th>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.subcategory" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td *ngIf="platformId == 'mx'">
            <select
              formControlName="corporationPropertyType"
              class="form-select"
            >
              <option
                *ngFor="let parentCorporationValue of parentCorporationList"
                [ngValue]="parentCorporationValue"
              >
                {{ "PROPERTY_TYPES." + parentCorporationValue | translate }}
              </option>
            </select>
          </td>
          <td *ngIf="platformId == 'mx'">
            <select
              formControlName="industry"
              [compareWith]="compareIndustries"
              class="form-select"
              [attr.disabled]="validateRetail() ? true : null"
            >
              <option *ngFor="let industry of industries" [ngValue]="industry"
                >{{ industry.name | langSelector }}
              </option>
            </select>
          </td>
          <td *ngIf="platformId == 'mx'">
            <select
              formControlName="industryRetail"
              [compareWith]="compareIndustries"
              class="form-select"
              [attr.disabled]="validateCorporationProprerty() ? true : null"
            >
              <option *ngFor="let retail of industryRetails" [ngValue]="retail"
                >{{ retail.name | langSelector }}
              </option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="tenant-table">
      <thead>
        <tr>
          <th>
            {{ "master-tenant.country" | translate }}
          </th>
          <th>
            {{ "master-tenant.website" | translate }}
          </th>
          <th>{{ "master-tenant.contactName" | translate }}</th>
          <th>{{ "master-tenant.contactPhone" | translate }}</th>
          <th>{{ "master-tenant.contactEmail" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <select formControlName="country" class="form-select">
              <option [ngValue]="null">{{
                "master-tenant.none" | translate
              }}</option>
              <option *ngFor="let country of countries" [ngValue]="country"
                >{{ country | langSelector }}
              </option>
            </select>
          </td>
          <td>
            <input
              matInput
              formControlName="contactUrl"
              class="table-input form-control"
              style="min-width: 190px;"
            />
          </td>
          <td>
            <input
              matInput
              formControlName="contactName"
              class="table-input form-control"
            />
          </td>
          <td>
            <input
              matInput
              formControlName="contactPhone"
              class="table-input form-control"
            />
          </td>
          <td>
            <input
              matInput
              type="text"
              formControlName="contactEmail"
              class="table-input form-control"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</mat-dialog-content>
<div class="col-md-12" style="text-align: end;">
  <mat-error *ngIf="akaError">
    {{ "master-tenant.errorAka" | translate }}
  </mat-error>
  <mat-error *ngIf="countryError">
    {{ "master-tenant.errorCountry" | translate }}
  </mat-error>
</div>

<mat-dialog-actions class="modal-actions" style="width: 100%;">
  <div style="display: flex; justify-content: space-between; width: 100%;">
    <!-- Left-aligned dummy buttons -->
    <div style="display: flex; gap: 8px; align-items: center;">
      <!-- Button is disabled until we approved this functionality, then remove the last 'true' statement -->
      <button
        mat-raised-button
        color="primary"
        class="combine-btn"
        [title]="'master-tenant.researcherDisabledTooltip' | translate"
        [disabled]="
          isResearcher || isCreating || tenantForm.invalid || !isCountryManager
        "
        (click)="openMergeCorporationModal()"
      >
        Combine
      </button>
      <button
        mat-raised-button
        color="primary"
        class="activate-btn"
        [disabled]="
          isResearcher ||
          isCreating ||
          (corporation?.status === 'Active' &&
            corporation?.propertyCount > 0) ||
          tenantForm.invalid
        "
        (click)="toggleActivation()"
      >
        {{
          corporation?.status === "Active"
            ? ("master-tenant.deactivate" | translate)
            : ("master-tenant.activate" | translate)
        }}
      </button>
      <button
        mat-raised-button
        color="primary"
        class="activate-btn"
        [disabled]="
          isResearcher ||
          isCreating ||
          corporation?.status !== 'Pending' ||
          tenantForm.invalid
        "
        *ngIf="corporation?.status === 'Pending'"
        (click)="disableTenant()"
      >
        {{ "master-tenant.deactivate" | translate }}
      </button>
    </div>

    <!-- Right-aligned real actions -->
    <div style="display: flex; gap: 8px; align-items: center;">
      <button mat-button (click)="close()" class="close-btn">
        {{ "master-tenant.close" | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="save()"
        [disabled]="tenantForm.invalid"
        class="save-btn"
        *ngIf="isResearcher"
      >
        {{
          isCreating
            ? ("master-tenant.submit" | translate)
            : ("master-tenant.update" | translate)
        }}
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="save()"
        [disabled]="tenantForm.invalid"
        class="save-btn"
        *ngIf="!isResearcher"
      >
        {{
          isCreating
            ? ("master-tenant.activate" | translate)
            : ("master-tenant.update" | translate)
        }}
      </button>
    </div>
  </div>
  <ng-template #mergeCorporationModal id="merge-corporation-modal">
    <div class="modal-header custom-modal-class-tenants">
      <h4 class="modal-title" style="font-weight: 600;">
        {{ "master-tenant.mergeCorporation" | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeMergeCorporationModal()"
      ></button>
    </div>
    <div class="modal-body">
      <div
        style="display: flex; align-items: center; gap: 12px; margin-top: 20px;"
      >
        <label
          for="mergeCorporationId"
          style="white-space: nowrap; font-weight: 500;"
        >
          {{ "master-tenant.mergeCorporationDescription" | translate }}:
        </label>
        <div style="display: flex; align-items: center; gap: 8px; flex: 1;">
          <input
            id="mergeCorporationId"
            name="mergeCorporationId"
            type="number"
            class="form-control"
            [value]="mergeCorporationId"
            (input)="onMergeCorporationIdChange($event)"
            style="width: 230px;"
            placeholder="{{ 'master-tenant.enterCorporationId' | translate }}"
          />
          <span
            *ngIf="mergeCorporationResult"
            style="font-weight: 500; color: #333;"
          >
            {{ mergeCorporationResult.name }}
          </span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeMergeCorporationModal()"
      >
        {{ "tenants-property.cancel" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="mergeCorporation()"
        [disabled]="
          mergeCorporationResult === null ||
          mergeCorporationResult === undefined
        "
      >
        {{ "master-tenant.merge" | translate }}
      </button>
    </div>
  </ng-template>
</mat-dialog-actions>
